export default "__VITE_ASSET__BacybPf5__"